import React from 'react';
import { Box, Typography } from '@mui/material';

// Rótulo de uma linha do insight (GATILHO, CONTEXTO, INTERESSE...).
const LeadInsightField = ({ label, children }) => (
  <Box>
    <Typography variant="overline" color="text.secondary" display="block">
      {label}
    </Typography>
    {children}
  </Box>
);

export default LeadInsightField;
